var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z",
    fill: "#00BA00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0077 47.6073L10.3043 35.0812C8.70201 33.3663 8.79398 30.6531 10.5089 29.0509C12.2238 27.4486 14.937 27.5408 16.5392 29.2555L25.5668 38.9174L39.8561 25.5664C39.9847 25.4462 40.119 25.3361 40.2578 25.2348L46.9775 18.9565C48.6924 17.3542 51.4059 17.4465 53.0079 19.1614C54.6102 20.876 54.5179 23.5894 52.8033 25.1917L32.2795 44.3678L32.2575 44.3443L25.1581 50.9777L22.0077 47.6073Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentSuccessIcon);
export default __webpack_public_path__ + "static/media/PaymentSuccessIcon.2e106cf859039c27082a427194dd7fe8.svg";
export { ForwardRef as ReactComponent };